








import Vue from "vue";
import { Component } from "vue-property-decorator";
import { State, Getter, Action, namespace } from "vuex-class";
import { apiService } from "./services/api.service";

const UserModule = namespace("userModule");

@Component
export default class App extends Vue {
  @UserModule.Action public logout;

  public created() {
    //  [App.vue specific] When App.vue is first loaded start the progress bar
    (this as any).$Progress.start();

    apiService.interceptors.response.use(
      (response) => {
        (this as any).$Progress.finish(); // finish when a response is received
        return response;
      },
      (error) => {
        (this as any).$Progress.fail(); // fail when a response is received
        const status = error.response.status;
        if (status === 401 || status === 403) {
          this.forceUserLogout();
        }

        return error;
      }
    );
  }

  public mounted() {
    //  [App.vue specific] When App.vue is finish loading finish the progress bar
    (this as any).$Progress.finish();
  }

  public forceUserLogout() {
    this.logout(true).then((result) => this.processLogoutResult());
  }

  private processLogoutResult() {
    this.$router.push({
      name: "LoginPage"
    });
  }
}
